import { useMediaQuery } from "@react-hook/media-query";

export type PageDividerProps = {
    topBgColor?: string;
    bottomBgColor?: string;
};

export default function PageDivider({
    topBgColor,
    bottomBgColor,
}: PageDividerProps) {
    const isLarge = useMediaQuery("(min-width: 1024px)");

    return (
        <div
            className="aspect-100/6 w-full lg:aspect-100/4"
            style={{ backgroundColor: topBgColor ?? "#F1F1F1" }}
        >
            <svg
                width="100%"
                height="100%"
                viewBox={isLarge ? "0 0 1440 57.6" : "0 0 1440 86.4"}
            >
                <svg width="692" height="141">
                    <path
                        d="M592 180.461L692 36.9045C177.5 -42.597 -68.1525 27.4875 -375.218 51.5554C-620.87 70.8098 -826.094 43.5328 -898 27.4875V180.461H592Z"
                        fill="#97BEBE"
                    />
                </svg>
                <svg width="1440" height="124">
                    <path
                        d="M1440 164.903V11.93C931.37 -15.8092 779.848 11.9294 472.783 35.9973C227.13 55.2516 21.9059 70.0453 -50 54V164.903H1440Z"
                        fill="#D46868"
                    />
                </svg>
                <svg width="1440" height="124" y="25" x="0">
                    <path
                        d="M-0.5 105V0C711.5 48 1257.17 31.1667 1440 17V105H-0.5Z"
                        fill={bottomBgColor ?? "#F1F1F1"}
                    />
                </svg>
            </svg>
        </div>
    );
}
